import { TDOOHLocationsReportTableFilters } from '../../../models/types'

export const selectDOOHLocationTableReportingFilters = ({
  reportingFilters: reportingDOOHLocationsTableFiltersState,
}: {
  reportingFilters: TDOOHLocationsReportTableFilters
}): TDOOHLocationsReportTableFilters => reportingDOOHLocationsTableFiltersState
